<template>
  <div>
    <h2 class="pt-6" data-testid="documents-event-section-title">{{ title }}</h2>
    <DocumentListItem v-for="documentable in props.documentables" :key="documentable.id" :documentable="documentable" />
  </div>
</template>

<script setup lang="ts">
import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import type { DocumentablesQuery, DocumentableEventsQuery } from '@/gql/myomr'
import { getLocalizedAttribute } from '@/helpers/localizedAttribute'

import DocumentListItem from './DocumentListItem.vue'

const { locale } = useI18n()

const props = defineProps<{
  documentables: DocumentablesQuery['documentables']['nodes']
  rootEvent: DocumentableEventsQuery['documentableEvents']['nodes'][number]
}>()

const title = computed(() =>
  getLocalizedAttribute({
    de: props.rootEvent.titleDe,
    en: props.rootEvent.titleEn,
    fallback: '',
    locale: locale.value,
  }),
)
</script>
